export interface VisuallyHiddenProps {
  text: string
}

export const VisuallyHidden = ({ text }: VisuallyHiddenProps) => {
  return <span className='visually-hidden' dangerouslySetInnerHTML={{ __html: text }}></span>
}
